import './Avatar.css';

import { CSSProperties, FC, useMemo } from 'react';

export interface AvatarProps {
  name: string;
  url?: string | null;
  ctmType?: CareTeamType;
  appointmentType?: string;
  style?: CSSProperties;
  size?: 'large' | 'small';
}

export enum CareTeamType {
  BCM = '#089C9C',
  Coach = '#39BC66',
  Therapist = '#FF7C5F',
  Prescriber = '#B666B6',
  Nurse = '#6471B4',
}

export const Avatar: FC<AvatarProps> = ({
  name,
  url,
  ctmType,
  appointmentType,
  style,
  size = 'small',
}) => {
  const initials = useMemo(() => {
    if (url) return null;

    return name
      .split(',')[0]
      .split(' ')
      .map(s => s[0])
      .join('')
      .toUpperCase();
  }, [name, url]);

  const background = useMemo(() => {
    if (ctmType) return ctmType;

    if (appointmentType) {
      return appointmentType.indexOf('bcm') > -1
        ? CareTeamType.BCM
        : appointmentType.indexOf('coach') > -1
        ? CareTeamType.Coach
        : appointmentType.indexOf('therap') > -1
        ? CareTeamType.Therapist
        : appointmentType?.indexOf('nurse') > -1
        ? CareTeamType.Nurse
        : CareTeamType.Prescriber;
    }

    return undefined;
  }, [ctmType, appointmentType]);

  return (
    <div
      className={`Avatar avatar_${size}`}
      style={{ backgroundColor: background ?? 'inherit', ...style }}
    >
      {initials ? (
        <div className="body-4">{initials}</div>
      ) : (
        <img src={url ?? undefined} alt={name} />
      )}
    </div>
  );
};
